import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'signinpage',
  templateUrl: './login-module.component.html',
  styleUrls: ['./login-module.component.css']
})
export class LoginModuleComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  onSignIp() {
    //alert('this');
    this.router.navigate(['signinpage']);
  }
    onSignUp(){
      this.router.navigate(['registernrh'])
    }
 

    


  

}
